import styled from 'styled-components';
import { colors, max } from 'constants/constants.styled';
import SubSubMenuSC from 'components/subSubMenuWrapper/SubSubMenu.styled';

/*
    Dědí vizuál sdílené pilulky (bílé pozadí, radius 2rem, shadow.table, .item,
    .active, hover podtržení) a dopisuje jen delty: reset <button>, focus ring,
    opravu tématu a chybějící media queries — základ nemá ani jednu.
 */
export default styled(SubSubMenuSC)`
    .item {
        margin: 0;
        background: none;
        border: 0;
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;

        /*
            Základ má v .active zmrazené colors.secondary (SubSubMenu.styled.ts:55),
            zatímco jeho vlastní hover už používá var(--colorSecondary) — aktivní
            pilulka tedy dnes nenásleduje theme_futsal.
         */
        &.active {
            background-color: var(--colorSecondary, ${colors.secondary});
            cursor: default;
        }

        &:focus-visible {
            outline: 2px solid ${colors.main};
            outline-offset: 2px;
        }
    }

    ${max.xs`
        width: 100%;

        .item {
            flex: 1 1 0;
            justify-content: center;
            text-align: center;
        }
    `}

    ${max.xxs`
        flex-direction: column;

        /*
            Základ nastavuje koncové rádiusy LONGHANDY na .item:first-child /
            :last-child (specificita 0-2-0). Override musí použít stejné longhandy
            a stejnou specificitu, jinak prohraje a stohovaná pilulka bude asymetrická.
         */
        .item:first-child,
        .item:last-child {
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
        }
    `}
`;
